import React from 'react';

const DashboardCard = ({ title, count, onClick }) => (
  <div className="dashboard-card" onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
    <h3>{title}</h3>
    <p>{count}</p>
  </div>
);

export default DashboardCard;
